import React from 'react'
import GenerateSummary from '../../components/Report/Summary/GenerateSummary'
import { Divider, Typography } from 'antd'

const SummaryPage = ({ userdata }) => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography.Title
          level={5}
          style={{
            margin: 0,
          }}
        >
          Summary
        </Typography.Title>
      </div>
      <Divider style={{ marginTop: 8 }} />
      <GenerateSummary />
    </>
  )
}

export default SummaryPage